// src/services/crewService.js
// 74차: 신규 생성 — 크루(친한 사람들끼리 모여 소속감을 느끼는 그룹) 기능.
//   정원 20명, 크루장 1 + 관리자 1(선택) 체제. 1인 1크루만 가능(users.crewId로 강제).
//   실시간 채팅 대신 댓글형 게시판(crewPosts)으로 단순화 — 일반 메시지/테마추천/
//   탈출기록 공유/모집글 자동연동을 전부 이 컬렉션 하나에 type으로 구분해서 담음.
//   포인트 차감은 기존 usePointsFIFO(→ CF usePointsFIFO_CF, 53차 보안 이관분)를 그대로
//   재사용 — 크루 전용 Cloud Function을 새로 만들지 않음. 크루 생성은 "문서 먼저 생성 →
//   포인트 차감 → 실패 시 문서 롤백" 순서로 처리해 "포인트만 나가고 크루는 안 생기는"
//   상태를 피함(반대로 포인트 부족은 흔한 실패라 롤백이 훨씬 쌈).
//   크루장/관리자만 볼 수 있는 개인정보 성격 없는 문서라 get/list는 공개로 열어둠
//   (가입 전에 크루를 미리 둘러볼 수 있게).

import {
  collection, doc, addDoc, getDoc, getDocs, updateDoc, deleteDoc,
  query, where, orderBy, limit, arrayUnion, arrayRemove,
  serverTimestamp, onSnapshot, runTransaction,
} from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { db, functionsAsia } from './firebase';
import { usePointsFIFO } from './recruitService';
import { todayStr } from '../utils/dateUtils';

const CREW_COL = 'crews';
const POST_COL = 'crewPosts';

// 80차 계속: 20 → 40 — 앱 전체 오픈 메시징(전체 유저가 서로 채팅)은 모더레이션 부담이
// 커 이 단계에선 보류하기로 하고, 대신 "크루 안에서 소통할 수 있는 사람 수 자체"를
// 늘려 리텐션 레버로 삼기로 함(기본값을 올리는 게 유료 상한을 올리는 것보다 효과적 —
// 대부분 크루가 정원 확장에 포인트를 쓰지 않으므로). firestore.rules의 폴백 기본값
// (crewData.get('maxMembers', 40))도 반드시 함께 갱신할 것 — 서버 검증 기준이라 어긋나면
// 신규(필드 없는) 크루가 즉시 정원 초과로 잘못 차단됨.
export const CREW_MEMBER_CAP       = 40; // 정원 기본값(crews.maxMembers 없는 기존 크루용 폴백)
// 80차 계속: 150P는 되돌리고 원래대로 300P 유지 — 대신 오픈 후 6개월간 한시적으로
// 할인된 가격을 적용하는 별도 함수(getCrewCreateCost)로 분리. 이 상수 자체는 "정가"
// 의미로 남기고(할인 종료 후 자동으로 이 값으로 복귀), 실제 결제에 쓸 금액은 반드시
// getCrewCreateCost()를 통해서만 구할 것 — 이 상수를 직접 쓰지 말 것.
export const CREW_CREATE_COST      = 300;
// 80차 계속: 오픈(2026-10-01) 후 6개월간 크루 생성 진입장벽을 낮추는 한시 프로모션 —
// 신규가입 보너스(500P)에서 정가(300P)를 내면 200P만 남아 "가입하자마자 크루부터
// 만들고 싶은" 신규유저의 첫 액션에 부담이 크다는 점을 콜드스타트 단계에서만 한시적으로
// 완화(정식 요금은 300P로 유지 — 매장 plan/할인율처럼 "계약일 기준 자동 만료"를 다시
// 도입하는 건 아니라는 점에 주의: 이건 매장별로 제각각인 계약일이 아니라 앱 전체 공통
// 오픈일 기준 고정 6개월이라 그때와 달리 매장별 예외 테이블이 필요 없어 단순함).
export const CREW_LAUNCH_PROMO_START = '2026-10-01';
export const CREW_LAUNCH_PROMO_END   = '2027-03-31'; // 오픈 후 6개월(10~3월)
export const CREW_LAUNCH_PROMO_COST  = 100;
export const isCrewLaunchPromoActive = (nowStr = todayStr()) =>
  nowStr >= CREW_LAUNCH_PROMO_START && nowStr <= CREW_LAUNCH_PROMO_END;
export const getCrewCreateCost = (nowStr = todayStr()) =>
  isCrewLaunchPromoActive(nowStr) ? CREW_LAUNCH_PROMO_COST : CREW_CREATE_COST;
export const CREW_RENAME_COST      = 100;
export const CREW_ACTION_LOCK_DAYS = 7;
export const CREW_DISBAND_MAX_MEMBERS = 5;

// 79차: 크루 정원 포인트 확장(크루장 전용) — crews.maxMembers 필드로 관리, 없으면
// CREW_MEMBER_CAP(40)으로 간주. 단계가 올라갈수록 비용을 높여(대형 크루일수록 운영
// 부담이 커지므로) 무분별한 최대치 증설을 억제.
// 80차 계속: [버그 수정, fork 재검토로 발견 — 실제 프로덕션 크루 3건에서 재현됨] 기존
// CREW_CAP_TIERS는 "목표값이 정확히 50/60/70이어야만" 다음 단계를 찾을 수 있는 고정
// 조회 테이블이었음 — 기본값이 20→40으로 오르면서 그 이전에 정원 확장을 시도했다가
// 결제 실패로 롤백되며 maxMembers:20이 그대로 남은 레거시 크루는 20+10=30이 테이블에
// 없어 실제로는 70까지 늘릴 수 있는데도 영구히 "이미 최대 정원"으로 오판됐음(firestore.
// rules는 애초에 "현재값+10, 70 이하"만 검증해 이 제약이 없었음 — 문제는 클라이언트의
// 고정 테이블 조회 방식이었음). "목표값이 테이블에 있어야 함" 대신 "현재값+10이 상한
// 이하면 항상 다음 단계가 있음"으로 바꿔 어떤 시작값에서도 안전하게 계산되도록 함.
export const CREW_MAX_MEMBER_CAP = 70;
export const getCrewCapUpgrade = (current) => {
  const to = current + 10;
  if (to > CREW_MAX_MEMBER_CAP) return null; // 더 못 늘림
  const cost = to <= 50 ? 300 : to <= 60 ? 500 : 1000;
  return { to, cost };
};
export const getCrewCap = (crew) => crew?.maxMembers || CREW_MEMBER_CAP;

// 78차 32차: 크루 레벨(Lv.1~5) — 크루가 올린 모집글 수(recruitLinkCount, crewPosts의
// recruit_link 타입 개수)와 활동일(daysActive, 개설일로부터 경과일)을 합산한 점수 기반.
// 모집글 1건 = 10점, 활동 1주일 = 1점(누적 아무리 오래돼도 활동 자체가 없으면 점수가
// 크게 안 쌓이게 모집글 비중을 더 높게 둠). 정확한 임계값은 실제 사용 데이터가 쌓이면
// 재조정 가능 — 실제 데이터가 없는 시점의 1차 추정치.
export const CREW_LEVEL_THRESHOLDS = [0, 10, 30, 60, 100]; // Lv1~5 시작 점수
export function getCrewLevel({ recruitLinkCount = 0, daysActive = 0 }) {
  const score = recruitLinkCount * 10 + Math.floor(daysActive / 7);
  let level = 1;
  for (let i = CREW_LEVEL_THRESHOLDS.length - 1; i >= 0; i--) {
    if (score >= CREW_LEVEL_THRESHOLDS[i]) { level = i + 1; break; }
  }
  return { level, score };
}

// "이런 사람이면 좋겠어요" 고정 태그 — 자유 텍스트 대신 필터링 가능하게
// 75차: 숙련도/장르선호/분위기/활동시간 그룹으로 분리(기존엔 8개가 구분 없이 한 줄에
// 섞여 있었음). 저장 형식(crew.tags: 문자열 배열)은 그대로 유지.
// 77차: 그룹별 선택지 다양화 + 그룹마다 "무관"(상관없음) 옵션 추가. 네 그룹 모두 같은
// 문자열("상관없음")로 두면 flat 배열(crew.tags)에 저장/렌더될 때 어느 그룹 것인지
// 구분이 안 되고, CreateCrewScreen.js의 toggleTag가 문자열 단위로 선택 상태를 판단해
// 다른 그룹인데 같은 문자열이면 같이 선택 표시되는 문제가 생겨 그룹별로 문구를 다르게 함
// ("숙련도 무관"/"장르 무관"/"분위기 무관"/"시간대 무관").
// 80차 후속: 체험형(공연형) 도입 이후 크루마다 선호 형식이 갈릴 수 있어 그룹 추가
// (다른 그룹과 동일하게 순수 표시용 태그 — 실제 필터/매칭 로직에 쓰이진 않음).
export const CREW_TAG_GROUPS = [
  { key: 'format',   label: '선호 형식', tags: ['방탈출 위주', '체험형 위주', '형식 무관'] },
  { key: 'level',    label: '숙련도',   tags: ['입문자 환영', '숙련자 환영', '고인물 환영', '숙련도 무관'] },
  { key: 'genre',    label: '선호 장르', tags: ['공포 선호', '추리 선호', 'SF 선호', '판타지 선호', '스릴러 선호', '코미디 선호', '장르 무관'] },
  { key: 'mood',     label: '분위기',   tags: ['편하게 즐기는', '빡겜 선호', '진지하게 몰입', '시끌벅적한', '분위기 무관'] },
  { key: 'schedule', label: '활동 시간', tags: ['주말에 활동', '평일 저녁 활동', '평일 낮 활동', '시간대 무관'] },
];

const isLocked = (crew) => new Date(crew.actionLockUntil) > new Date();

// ─── 내 크루 조회 (1인 1크루 강제 — users.crewId로도 확인) ───
export const getMyCrew = async (uid) => {
  const q = query(
    collection(db, CREW_COL),
    where('memberUids', 'array-contains', uid),
    where('isDisbanded', '==', false),
  );
  const snap = await getDocs(q);
  return snap.empty ? null : { id: snap.docs[0].id, ...snap.docs[0].data() };
};

export const getCrewById = async (crewId) => {
  const snap = await getDoc(doc(db, CREW_COL, crewId));
  return snap.exists() ? { id: snap.id, ...snap.data() } : null;
};

// ─── 크루 둘러보기(가입 전) — 정원 안 찬 크루만, 최신순 ───────
export const listBrowsableCrews = async (lim = 30) => {
  const snap = await getDocs(query(
    collection(db, CREW_COL),
    where('isDisbanded', '==', false),
    orderBy('createdAt', 'desc'),
    limit(lim),
  ));
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
};

// ─── 크루 랭킹(리더보드) ────────────────────────────────────────
// 80차 계속: crewPosts는 이제 크루 멤버만 읽을 수 있어(사생활 보호 강화) 클라이언트가
// 전체 크루를 순회하며 게시글을 직접 세는 방식은 더 이상 불가능 — 대신 crews.recruitLinkCount
// (onCrewPostCreated 트리거가 서버에서 유지하는 카운터, functions/index.js)만으로 점수를
// 계산. listBrowsableCrews와 동일한 공개 쿼리를 재사용, 정렬만 클라이언트에서 수행
// (크루 개수가 아직 적은 초기 단계라 별도 서버 집계/인덱스 없이 충분).
export const listTopCrews = async (lim = 10) => {
  const all = await listBrowsableCrews(100);
  const scored = all.map(crew => {
    const daysActive = crew.createdAt
      ? Math.max(0, Math.floor((Date.now() - new Date(crew.createdAt).getTime()) / 86400000))
      : 0;
    const { level, score } = getCrewLevel({ recruitLinkCount: crew.recruitLinkCount || 0, daysActive });
    return { ...crew, level, score };
  });
  scored.sort((a, b) => b.score - a.score);
  return scored.slice(0, lim);
};

// ─── 크루 생성 ────────────────────────────────────────────────
// 75차: ownerNickname 스냅샷 추가 — 비회원/미가입 회원용 크루 둘러보기 카드에
// "크루장 닉네임"을 보여주려면 매번 users 문서를 조회해야 하는데(N+1 쿼리 + 비회원은
// users list 권한도 없음), 다른 스냅샷 필드(authorName 등)와 동일하게 생성 시점에 박아둠.
export const createCrew = async ({ uid, ownerNickname = '익명', name, description = '', tags = [] }) => {
  const trimmed = name.trim();
  if (trimmed.length < 2)  throw new Error('NAME_TOO_SHORT');
  if (trimmed.length > 16) throw new Error('NAME_TOO_LONG');
  if (await getMyCrew(uid)) throw new Error('ALREADY_IN_CREW');

  // 79차: 원래 "문서 먼저 생성 → 포인트 차감 → 실패 시 deleteDoc 롤백" 순서였는데,
  // firestore.rules의 crews delete가 총괄관리자 전용(isSuperAdmin())이라 본인조차
  // 자기가 방금 만든 크루를 못 지워 롤백이 항상 permission-denied로 조용히 실패하고
  // 있었음(실기기 QA로 발견) — 포인트 부족으로 생성이 실패해도 크루 문서는 그대로
  // 남고 onCrewCreated 트리거가 users.crewId까지 세팅해버려, 유저 입장에선 "실패"로
  // 보이는데 실제로는 포인트 차감 없이 크루를 갖게 되는 정합성 버그였음. usePointsFIFO_CF가
  // 이미 원자적 트랜잭션이라 실패 확률이 훨씬 낮은 addDoc보다 먼저 실행하는 쪽이 안전 —
  // 포인트 차감을 먼저 하고 성공했을 때만 크루 문서를 생성하도록 순서를 뒤집음.
  // 80차 계속: 오픈 후 6개월 한시 프로모션가(getCrewCreateCost) 적용 — 기간이 지나면
  // 자동으로 정가(CREW_CREATE_COST)로 복귀.
  await usePointsFIFO(uid, getCrewCreateCost(), `크루 생성 - ${trimmed}`);

  const now = new Date();
  const actionLockUntil = new Date(now.getTime() + CREW_ACTION_LOCK_DAYS * 24 * 60 * 60 * 1000).toISOString();
  const ref = await addDoc(collection(db, CREW_COL), {
    ownerUid: uid, ownerNickname, managerUid: null,
    memberUids: [uid], pendingMemberUids: [],
    name: trimmed, description: description.trim(), tags,
    createdAt: now.toISOString(), actionLockUntil, isDisbanded: false,
  });

  // 78차 56차: 여기서 클라이언트가 직접 updateDoc(users/{uid}, {crewId, crewName})을
  // 호출했었는데, firestore.rules가 이 두 필드를 본인 self-update로도 막고 있어(75차,
  // 사칭 방지) 크루는 이미 생성되고 300P도 이미 차감된 뒤에 매번 permission-denied로
  // 실패하고 있었음 — functions/index.js의 신규 onCrewCreated(crews onCreate 트리거,
  // Admin SDK)로 이관, 여기서는 더 이상 건드리지 않음.
  return ref.id;
};

// ─── 크루명 변경 (포인트 차감) ────────────────────────────────
// 79차: [버그 수정] 형제 함수 expandCrewCap은 포인트 차감 전에 크루장 여부를 확인하는데
// 이 함수는 그 검증이 아예 없었음(전수 정독으로 발견) — CrewManageScreen.js의 UI가
// 크루장에게만 이 버튼을 보여줘서 지금까지 가려져 있었을 뿐, 이 함수를 직접 호출하면
// 크루장이 아닌 일반 멤버도 100P가 그대로 차감된 뒤(usePointsFIFO_CF는 "본인 포인트인가"만
// 봄) 뒤이은 updateDoc이 firestore.rules(크루장/관리자만 update 가능)에 막혀 실패해도
// 자동 환불이 없어 포인트만 조용히 날아가는 구조였음. expandCrewCap과 동일한 검증 추가.
export const renameCrew = async ({ crewId, uid, newName }) => {
  const crew = await getCrewById(crewId);
  if (!crew) throw new Error('NOT_FOUND');
  if (crew.ownerUid !== uid) throw new Error('NOT_LEADER');
  const trimmed = newName.trim();
  if (trimmed.length < 2)  throw new Error('NAME_TOO_SHORT');
  if (trimmed.length > 16) throw new Error('NAME_TOO_LONG');
  await usePointsFIFO(uid, CREW_RENAME_COST, `크루명 변경 - ${trimmed}`);
  await updateDoc(doc(db, CREW_COL, crewId), { name: trimmed });
  // 멤버들의 users.crewName 전파는 functions/index.js의 onCrewUpdated 트리거가 처리
};

// ─── 정원 확장(크루장 전용, 포인트 차감) ────────────────────────
// 79차: 20→30→40→50 순으로 한 단계씩만 확장 가능.
// 80차 후속: [버그 수정, fork로 발견] "크루장 1인만 누르는 액션이라 동시성 위험 없다"는
// 전제가 같은 기기 더블탭에만 맞고, 서로 다른 세션/기기에서 거의 동시에 호출하면 둘 다
// 같은 current를 읽어 각자 포인트를 정상 차감하는데 실제 정원은 한 단계만 오르는 이중결제가
// 실제로 재현됨 — 정원 선점(트랜잭션)을 먼저 확정하고, 그 다음에만 포인트를 차감하도록
// 순서를 뒤집음. 두 번째 호출은 트랜잭션 단계에서 CAP_CHANGED로 실패해 포인트를 아예 안 냄.
// 79차에 grantPointsCF(임의 사유로 포인트를 만들어낼 수 있던 취약점)가 삭제되어 클라이언트가
// 쓸 수 있는 범용 환불 수단이 없으므로, "결제 실패 시 방금 만든 것을 되돌린다"(크루 생성과
// 동일 원칙)를 여기서도 따름 — 포인트 차감이 실패하면(잔액부족 등) 정원 선점을 되돌림.
// 80차 계속: [기능 추가] 정원이 가득 찬 상태(크루장이 실제로 사람을 다 채워서 성장시킨
// 상태)에서 확장하면 무료 — 초대/성장을 유도하는 성장 루프. "누가 초대했는지"를 따로
// 추적하는 인프라 없이도, 정원을 다 채우는 것 자체가 "크루장이 사람을 모았다"는 증거이므로
// 이 조건 하나로 충분(신규 데이터 모델 불필요). 가득 안 찼으면 기존 유료 확장 그대로 유지.
export const expandCrewCap = async ({ crewId, uid }) => {
  const crew = await getCrewById(crewId);
  if (!crew) throw new Error('NOT_FOUND');
  if (crew.ownerUid !== uid) throw new Error('NOT_LEADER');
  const current = getCrewCap(crew);
  const tier = getCrewCapUpgrade(current);
  if (!tier) throw new Error('ALREADY_MAX');
  const ref = doc(db, CREW_COL, crewId);
  let isFull = false;
  await runTransaction(db, async (tx) => {
    const snap = await tx.get(ref);
    if (!snap.exists()) throw new Error('NOT_FOUND');
    const data = snap.data();
    if (getCrewCap(data) !== current) throw new Error('CAP_CHANGED');
    isFull = (data.memberUids || []).length >= current;
    tx.update(ref, { maxMembers: tier.to });
  });
  if (isFull) return { cost: 0, to: tier.to };
  try {
    await usePointsFIFO(uid, tier.cost, `크루 정원 확장 - ${current}명 → ${tier.to}명`);
  } catch (e) {
    await updateDoc(ref, { maxMembers: current }).catch(() => {});
    throw e;
  }
  return { cost: tier.cost, to: tier.to };
};

// ─── 가입 신청 / 취소 ──────────────────────────────────────────
export const requestJoinCrew = async (crewId, uid) => {
  if (await getMyCrew(uid)) throw new Error('ALREADY_IN_CREW');
  await updateDoc(doc(db, CREW_COL, crewId), { pendingMemberUids: arrayUnion(uid) });
};
export const cancelJoinRequest = async (crewId, uid) => {
  await updateDoc(doc(db, CREW_COL, crewId), { pendingMemberUids: arrayRemove(uid) });
};

// ─── 가입 승인 / 거절 (크루장·관리자) ──────────────────────────
// 78차: getDoc()으로 정원(CREW_MEMBER_CAP)을 확인하고 updateDoc()으로 쓰는 read-then-write라
// 동시성 방어가 없었음(전수조사로 발견, recruitService.js의 approveParticipant와 동일 유형) —
// 크루장/관리자가 대기자 여러 명을 빠르게 연속 승인하면 정원 20명을 넘겨 memberUids가
// 쌓일 수 있었음. runTransaction으로 원자성 확보.
export const approveCrewMember = async (crewId, uid) => {
  // 78차 45차: requestJoinCrew는 신청 시점에만 "이미 다른 크루 소속"을 막고, 신청
  // 자체(pendingMemberUids)는 여러 크루에 동시에 걸어둘 수 있었음 — 승인은 정원/중복
  // 승인만 체크하고 "이미 다른 크루 멤버인지"는 전혀 확인하지 않아, A 크루가 승인한
  // 직후 B 크루도 같은 신청을 승인하면 한 유저가 두 크루의 memberUids에 동시에 남는
  // 1인 1크루 위반(유령 멤버)이 가능했음. Firestore 클라이언트 트랜잭션은 쿼리 읽기를
  // 지원하지 않아 완전한 원자성 보장은 불가하지만, 승인 직전 재확인으로 실사용에서
  // 유일하게 가능한 경로(서로 다른 크루장이 몇 초 간격으로 승인)를 막는다.
  const existingCrew = await getMyCrew(uid);
  if (existingCrew && existingCrew.id !== crewId) {
    await updateDoc(doc(db, CREW_COL, crewId), { pendingMemberUids: arrayRemove(uid) });
    throw new Error('이미 다른 크루에 가입된 사용자예요. 신청이 자동으로 취소됐어요.');
  }

  const ref = doc(db, CREW_COL, crewId);
  await runTransaction(db, async (transaction) => {
    const snap = await transaction.get(ref);
    if (!snap.exists()) throw new Error('NOT_FOUND');
    const crew = snap.data();
    if ((crew.memberUids || []).includes(uid)) return; // 이미 승인된 신청 — 중복 승인 무시
    if ((crew.memberUids || []).length >= getCrewCap(crew)) throw new Error('CREW_FULL');
    transaction.update(ref, {
      memberUids: arrayUnion(uid),
      pendingMemberUids: arrayRemove(uid),
    });
  });
};
export const rejectCrewMember = async (crewId, uid) => {
  await updateDoc(doc(db, CREW_COL, crewId), { pendingMemberUids: arrayRemove(uid) });
};

// ─── 강퇴 (크루장·관리자, 크루장 본인은 강퇴 대상 불가) ────────
export const kickCrewMember = async (crewId, targetUid) => {
  const crew = await getCrewById(crewId);
  if (!crew) throw new Error('NOT_FOUND');
  if (targetUid === crew.ownerUid) throw new Error('CANNOT_KICK_LEADER');
  const patch = { memberUids: arrayRemove(targetUid) };
  if (crew.managerUid === targetUid) patch.managerUid = null;
  await updateDoc(doc(db, CREW_COL, crewId), patch);
};

// 78차 66차: 크루 대표사진 — 자물쇠 아이콘 고정 대신 크루장/관리자가 직접 지정 가능하게.
// firestore.rules의 crews update가 이미 크루장/관리자에게 전체 필드를 열어두고 있어
// 규칙 변경 불필요, 업로드는 CrewManageScreen.js에서 담당(이미지 압축→Storage 업로드).
export const updateCrewImage = async (crewId, imageUrl) => {
  await updateDoc(doc(db, CREW_COL, crewId), { imageUrl });
};

// ─── 관리자 지정 / 해제 (크루장 전용) ──────────────────────────
export const appointManager = async (crewId, uid) => {
  await updateDoc(doc(db, CREW_COL, crewId), { managerUid: uid });
};
export const dismissManager = async (crewId) => {
  await updateDoc(doc(db, CREW_COL, crewId), { managerUid: null });
};

// ─── 탈퇴 (일반 멤버·관리자) — 7일 잠금 적용 ───────────────────
export const leaveCrew = async (crewId, uid) => {
  const crew = await getCrewById(crewId);
  if (!crew) throw new Error('NOT_FOUND');
  if (crew.ownerUid === uid) throw new Error('LEADER_MUST_USE_LEADER_LEAVE');
  if (isLocked(crew)) throw new Error('ACTION_LOCKED');
  const patch = { memberUids: arrayRemove(uid) };
  if (crew.managerUid === uid) patch.managerUid = null;
  await updateDoc(doc(db, CREW_COL, crewId), patch);
  // 78차 56차: createCrew와 동일한 유형 — 이 users.crewId/crewName self-update도
  // firestore.rules에 막혀 매번 permission-denied였음(탈퇴 자체는 위 crews 업데이트로
  // 이미 완료됐는데도 화면엔 실패로 표시됐을 것). 어차피 onCrewUpdated 트리거가 위
  // memberUids 변경(removed)을 보고 이 필드를 이미 null로 정리하므로 중복 제거.
};

// ─── 크루장 탈퇴 — 관리자가 있으면 자동 승계, 없으면 차단 ──────
export const leaderLeaveCrew = async (crewId, uid) => {
  const crew = await getCrewById(crewId);
  if (!crew) throw new Error('NOT_FOUND');
  if (crew.ownerUid !== uid) throw new Error('NOT_LEADER');
  if (isLocked(crew)) throw new Error('ACTION_LOCKED');
  if (!crew.managerUid) throw new Error('NEED_MANAGER'); // "관리자를 먼저 지정해주세요" 안내용
  await updateDoc(doc(db, CREW_COL, crewId), {
    ownerUid: crew.managerUid,
    managerUid: null,
    memberUids: arrayRemove(uid),
  });
  // 78차 56차: leaveCrew와 동일한 이유로 제거 — onCrewUpdated 트리거가 처리.
};

// ─── 해체 (크루장 전용, 총원 5명 이하 + 7일 경과 후) ────────────
export const disbandCrew = async (crewId, uid) => {
  const crew = await getCrewById(crewId);
  if (!crew) throw new Error('NOT_FOUND');
  if (crew.ownerUid !== uid) throw new Error('NOT_LEADER');
  if (isLocked(crew)) throw new Error('ACTION_LOCKED');
  if ((crew.memberUids || []).length > CREW_DISBAND_MAX_MEMBERS) throw new Error('TOO_MANY_MEMBERS');
  // 포인트 환불 없음(요청사항) — memberUids를 비워서 onCrewUpdated 트리거가 전원의
  // users.crewId/crewName을 정리하도록 함
  await updateDoc(doc(db, CREW_COL, crewId), { isDisbanded: true, memberUids: [], pendingMemberUids: [] });
};

// 75차: 멤버/신청자 프로필 조회 — 기존엔 클라에서 users 컬렉션을 직접 쿼리했는데,
// firestore.rules상 users의 list는 관리자만 허용이라 크루장/관리자(일반 유저)가 호출하면
// 항상 permission-denied였음(CrewManageScreen.js가 "크루 정보를 불러올 수 없습니다"만
// 뜨던 원인). Admin SDK로 크루장/관리자 여부를 검증하는 CF로 이관.
export const getCrewMemberProfilesCF = async (crewId) => {
  const cf = httpsCallable(functionsAsia, 'getCrewMemberProfilesCF');
  const result = await cf({ crewId });
  return result.data; // { members, pending }
};

// ─── 크루 게시판(댓글형 피드) ───────────────────────────────────
export const listenCrewPosts = (crewId, cb, lim = 100) => {
  const q = query(
    collection(db, POST_COL),
    where('crewId', '==', crewId),
    orderBy('createdAt', 'desc'),
    limit(lim),
  );
  // 78차 69차: "채팅 느낌"으로 오래된 것부터(reverse) 보여주던 것 → 최신 댓글이 위로
  // 오도록 요청받아 서버 정렬(createdAt desc) 그대로 사용.
  return onSnapshot(q, snap => {
    cb(snap.docs.map(d => ({ id: d.id, ...d.data() })));
  }, () => cb([]));
};

const addCrewPost = (payload) => addDoc(collection(db, POST_COL), {
  productId: null, recruitId: null, imageUrl: null, text: '',
  ...payload,
  createdAt: serverTimestamp(),
});

// 80차 계속: 메시지 카드에 발신자 대표 이미지를 보여주기 위해 작성 시점 photoURL 스냅샷 저장
// (다른 크루 게시글 스냅샷 필드들과 동일 관행 — 이후 프로필 사진이 바뀌어도 과거 글은 그대로 유지).
// 80차 계속: @멘션/@전체 — mentions(uid 배열)/mentionAll은 클라이언트가 텍스트를 미리
// 파싱한 "힌트"일 뿐, 실제 알림 발송 여부는 functions/index.js의 onCrewPostCreated가
// crews.memberUids와 다시 대조해 서버에서 최종 결정(클라이언트 조작 방지).
export const addCrewMessage = ({ crewId, uid, nickname, text, photoURL = null, mentions = [], mentionAll = false }) =>
  addCrewPost({ crewId, uid, nickname, type: 'message', text, photoURL, mentions, mentionAll });

// 80차 계속: @닉네임/@전체 파싱 로직은 순수 함수라 src/utils/mentionUtils.js로 분리
// (crewService.js는 Firebase 클라이언트 초기화를 거쳐 jest node 환경에서 테스트 불가 —
// dateUtils.js와 동일한 이유). 기존 호출부(CrewScreen.js)가 계속 crewService에서
// import할 수 있도록 재노출만 함.
export { parseMentions } from '../utils/mentionUtils';

// 78차 66차: 크루장/관리자 전용 공지사항 — 일반 메시지와 구분되게 type:'notice'로 저장,
// firestore.rules가 이 타입은 크루장/관리자만 생성 가능하도록 강제. 별도 컬렉션/화면 없이
// 기존 게시판 피드에 그대로 섞여 노출(강조 스타일만 다르게)해 일반 멤버도 자연히 보게 함.
export const addCrewNotice = ({ crewId, uid, nickname, title, text }) =>
  addCrewPost({ crewId, uid, nickname, type: 'notice', title: title.trim(), text: text.trim() });

// 78차 70차: 공지사항 수정 — firestore.rules가 type:'notice' + title/text만 바꾸는
// update를 크루장/관리자에게 허용.
export const updateCrewNotice = (postId, { title, text }) =>
  updateDoc(doc(db, POST_COL, postId), { title: (title || '').trim(), text: text.trim() });

// 78차 70차: 게시글 삭제(현재는 공지사항 전용 화면에서만 사용) — firestore.rules가
// notice 타입에 한해 작성자 본인이 아니어도 현재 크루장/관리자면 삭제 가능하도록 허용.
export const deleteCrewPost = (postId) => deleteDoc(doc(db, POST_COL, postId));

// 78차 70차: 공지사항만 모아보기 — 새로 가입한 멤버가 지난 공지를 놓치지 않도록,
// 채팅형 피드에 섞인 공지를 시간순으로 따로 조회.
export const getCrewNotices = async (crewId) => {
  const snap = await getDocs(query(
    collection(db, POST_COL),
    where('crewId', '==', crewId),
    where('type', '==', 'notice'),
    orderBy('createdAt', 'desc'),
  ));
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
};

// 75차: 테마 추천 게시글에 썸네일/매장명/장르/난이도/가격 스냅샷 추가 — 기존엔 텍스트
// 한 줄로만 표시돼 "추천" 느낌이 안 났음(검색해서 고르는 것까지는 이미 되고 있었음).
// 게시판 피드마다 매번 상품을 다시 조회하지 않도록(N+1 방지) 작성 시점 값을 그대로 저장
// — 다른 스냅샷 필드(authorName, ownerNickname 등)와 동일한 패턴.
export const addCrewThemeRecommend = ({
  crewId, uid, nickname, productId, text,
  imageUrl = null, storeName = '', genre = '', difficulty = '', minPrice = null,
  bookingFormat = 'room', pricePerPerson = 0, seatingType = 'shared', isAdultOnly = false,
}) =>
  addCrewPost({ crewId, uid, nickname, type: 'theme_recommend', productId, text, imageUrl, storeName, genre, difficulty, minPrice, bookingFormat, pricePerPerson, seatingType, isAdultOnly });

// 78차 32차: escapeResult(성공/실패, 리뷰 작성 시 이미 기록되는 값을 그대로 넘겨받음)
// 저장 추가 — 크루 "성공률" 스탯 집계에 사용(CrewScreen.js). null이면(과거 데이터 등
// 결과를 모르는 경우) 집계에서 제외.
// 78차 69차: escapeTime/hintCount 저장 추가 — 매장이 이미 입력해둔 소요시간·힌트 횟수를
// 그대로 공유 카드에 노출(자랑거리 부재 신고 반영).
// 80차 후속: 체험형(bookingFormat:'show')은 성공/실패 개념이 없어 "관람 추천" 카드로 다르게
// 렌더링됨 — theme_recommend와 동일한 스냅샷 필드(productId/genre/storeName/pricePerPerson/
// seatingType) + comment(개인 추천 문구)를 함께 저장.
export const addCrewEscapeShare = ({
  crewId, uid, nickname, imageUrl, text, escapeResult = null, escapeTime = null, hintCount = null,
  bookingFormat = 'room', productId = null, comment = null, genre = '', storeName = '',
  pricePerPerson = 0, seatingType = 'shared', isAdultOnly = false,
}) =>
  addCrewPost({
    crewId, uid, nickname, type: 'escape_record', imageUrl, text, escapeResult, escapeTime, hintCount,
    bookingFormat, productId, comment, genre, storeName, pricePerPerson, seatingType, isAdultOnly,
  });

// 74차: RecruitWriteScreen.js에서 "크루원 모집으로 등록" 토글을 켠 채로 글을 올리면 호출 —
// 크루 게시판에 모집글 카드가 자동으로 나타나게 함
// 78차: 카드에 보이는 정보가 제목뿐이라 "어떤 테마를 모집하는지" 등 정보가 너무 적다는
// 신고 — theme_recommend와 동일한 패턴으로 작성 시점 스냅샷(테마명/이미지/지역/일시/인원)
// 추가 저장(N+1 조회 방지, RecruitWriteScreen.js가 이미 갖고 있는 값을 그대로 넘김).
export const addCrewRecruitLink = ({
  crewId, uid, nickname, recruitId, recruitTitle,
  productName = '', imageUrl = null, region = '', scheduledDate = '', scheduledTime = '', totalSlots = null,
  bookingFormat = 'room', isAdultOnly = false, // 80차 후속: 크루 게시판 연동 카드에도 형식/19금 뱃지 노출용
}) =>
  addCrewPost({
    crewId, uid, nickname, type: 'recruit_link', recruitId, text: recruitTitle || '',
    productName, imageUrl, region, scheduledDate, scheduledTime, totalSlots, bookingFormat, isAdultOnly,
  });

// 78차 42차: 크루 게시판 신고 — reviewService.js의 reportReview()와 동일한 패턴으로
// 기존 reports 컬렉션(모집글 신고 전용이었음)을 재사용, crewPostId 필드로 구분.
// SuperAdminUserReportScreen의 기존 신고 관리 UI를 그대로 재사용(화면 쪽 변경 불필요).
export const reportCrewPost = async ({ crewPostId, reporterUid, reporterName, post, reason }) => {
  if (!crewPostId || !reporterUid || !reason) throw new Error('필수 파라미터 누락');

  const dupSnap = await getDocs(query(
    collection(db, 'reports'),
    where('reporterUid', '==', reporterUid),
    where('crewPostId', '==', crewPostId),
  ));
  if (!dupSnap.empty) throw new Error('ALREADY_REPORTED');

  await addDoc(collection(db, 'reports'), {
    crewPostId,
    reporterUid,
    reporterName,
    targetUid: post?.uid || null,
    targetName: post?.nickname || '익명',
    reason,
    title: '크루 게시글 신고',
    createdAt: serverTimestamp(),
    status: 'pending',
  });
};
